import * as React from 'react';
import { Box, Grid, Modal } from '@mui/material';
import RoundButton from '../components/roundButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

export default function WarningModal({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box className="modal-common warning-modal">
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            onClick={handleClose}
            className="align-right"
          >
            <CloseRoundedIcon />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className="normal-header">
            Safety Warning
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className="mt-1">
            FAILURE OR IMPROPER SELECTION OR IMPROPER USE OF THE PRODUCTS
            DESCRIBED HEREIN OR RELATED ITEMS CAN CAUSE DEATH, PERSONAL INJURY
            AND PROPERTY DAMAGE. This document and other information from
            Parker-Hannifin Corporation, its subsidiaries and authorized
            distributors provide product or system options for further
            investigation by users having technical expertise. The user, through
            its own analysis and testing, is solely responsible for making the
            final selection of the system and components and assuring that all
            performance, endurance, maintenance, safety and warning requirements
            of the application are met. The user must analyze all aspects of the
            application, follow applicable industry standards, and follow the
            information concerning the product in the current product catalog
            and in any other materials provided from Parker or its subsidiaries
            or authorized distributors. To the extent that Parker or its
            subsidiaries or authorized distributors provide component or system
            options based upon data or specifications provided by the user, the
            user is responsible for determining that such data and
            specifications are suitable and sufficient for all applications and
            reasonably foreseeable uses of the components or systems...
            <span
              className="link"
              onClick={() => {
                window.open(
                  'https://www.parker.com/portal/site/PARKER/menuitem.c9e55a6ea039d4fdfd40eae8237ad1ca/?vgnextoid=f65d904cf58b2110VgnVCM100000c9040d0aRCRD&vgnextchannel=f65d904cf58b2110VgnVCM100000c9040d0aRCRD&vgnextfmt=EN',
                  '_blank'
                );
              }}
            >
              Click here to view all product safety information.{' '}
            </span>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className="align-center">
            <RoundButton
              name={'Close'}
              classname="yellow-button w-200"
              onClick={handleClose}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
